export default __webpack_public_path__ + "static/yahoo-695f88abe339932556e79a8d3c5551f4.jpeg";